import { render } from "./filter-shortcut-links.vue?vue&type=template&id=aa507c80"
import script from "./filter-shortcut-links.vue?vue&type=script&lang=js"
export * from "./filter-shortcut-links.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__